import { useMemo } from "react"
import { chain, get, isEmpty } from "lodash"

// We make sure the queryStringSelectedMetric exists inside the availableMetrics
// If it doesn't we default back to the first of the availableMetrics
export function useSelectedMetric(availableMetrics, { id: queryStringMetricId } = {}) {
  return useMemo(() => {
    if (queryStringMetricId) {
      const selectedMetric = chain(availableMetrics)
        .map(({ options }) => options)
        .flatten()
        .find(({ id }) => queryStringMetricId === id)
        .value()

      if (!isEmpty(selectedMetric)) {
        return selectedMetric
      }
    }
    return get(availableMetrics, "0.options.0")
  }, [availableMetrics, queryStringMetricId])
}
